import { gql } from "@apollo/client";

export const notification_base_fields = `
  Creator {
    UserId
    Firstname
    Lastname
  }
  ToUser {
    UserId
    Firstname
    Lastname
  }
  NotificationType {
    NotificationTypeId
    Name
  }
  NotificationAction {
    NotificationActionId
    ActionType
    ResponseType
    NotificationActionValue {
      Name
      NotificationActionValueId
    }
  }
  NotificationText {
    Text
    Created
    LangCode
  }
  NotificationId
  Seen
  Created
  Updated
	`;

export const GET_NOTIFICATION = gql(
  `query notifications($UserId: Int!) { 
      notifications(data: {UserId: $UserId}) {
        ` +
    notification_base_fields +
    `
      }}`
);
